// extracted by mini-css-extract-plugin
module.exports = {"priceChartHeroBody":"styles_priceChartHeroBody__Qghvv","disclaimer":"styles_disclaimer__g8tOj"};